import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_leads-brands_page_qanda-click';
/**
 * Track the click of the question expanding button.
pass in question name as parameter
*/
export function trackBrandLeadsBrandsPageQandaClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
